import React, { useEffect, useState } from "react";
import axios from "axios";
import Card from "../Components/Card";
import SimpleTable from "../Components/SimpleTable";
import Badge from "../Components/Badge";
import { fetchRoles } from "../Data/ROLES";
import BlueButton from "./BlueButton";
import { BRAND } from "../css/brand";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RefreshCw, XCircle } from "lucide-react";
import Loader from "./Loader";
import TableSkeleton from "./TableSkeleton";

export default function AssignedKeysReport({ brand, loginUserID, CompanyID }) {
  const [assignedReports, setAssignedReports] = useState([]);
  const [reportPage, setReportPage] = useState(1);
  const [reportTotalPages, setReportTotalPages] = useState(1);
  const [loadingReport, setLoadingReport] = useState(false);
  const [errorReport, setErrorReport] = useState(null);

  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reportTotal, setReportTotal] = useState("");
  // const [currentPage, setCurrentPage] = useState(1);
  // const [totalPages, setTotalPages] = useState(1);

  const rowsPerPage = 10;

  const authUserString = sessionStorage.getItem("authUserData1");
let authUser = null;
let userRole = null;

try {
  authUser = JSON.parse(authUserString);
  userRole = authUser?.data?.[0]?.role || authUser?.data?.role || null;
} catch (e) {
  console.error("Invalid session data:", e);
}

  
  useEffect(() => {
  async function loadRoles() {
    try {
      const data = await fetchRoles();
      console.log("All roles fetched:", data);
      console.log("Role from session:", userRole);

      // Convert keys to numbers safely
      const allRoles = Object.entries(data).map(([id, name]) => ({
        id: Number(id),
        name,
      }));

      let allowedIds = [];

      switch (Number(userRole)) {
        case 2: // Company
          allowedIds = [3, 4, 5, 7];
          break;
        case 3: // CNF
          allowedIds = [4, 5, 7];
          break;
        case 4: // Super Stockist
          allowedIds = [5, 7];
          break;
        case 5: // Distributor
          allowedIds = [7]; // ✅ Distributor should directly assign to Retailer
          break;
        default:
          allowedIds = [7];
          console.warn("Unknown or missing role; defaulting to Retailer only.");
      }

      const filtered = allRoles.filter((r) => allowedIds.includes(r.id));
      filtered.sort((a, b) => a.id - b.id);
      setRoles(filtered);

      console.log("Filtered roles available:", filtered);
    } catch (error) {
      console.error("Error loading roles:", error);
      setRoles([]);
    }
  }

  loadRoles();
}, [userRole]);



  // 🔹 Fetch users for selected role
  // 🔹 Fetch users for selected role (role-based ID param)
useEffect(() => {
  const fetchUsers = async () => {
    if (!selectedRole) return;

    let url = `https://spillas.com/api/v1/org_user?role=${selectedRole}`;
    const roleNum = Number(userRole);

    // Dynamically add correct param
    if (roleNum === 2 && loginUserID) {
      url += `&company_id=${loginUserID}`;
    } else if (roleNum === 3 && loginUserID) {
      url += `&cnf_id=${loginUserID}`;
    } else if (roleNum === 4 && loginUserID) {
      url += `&ss_id=${loginUserID}`;
    } else if (roleNum === 5 && loginUserID) {
      url += `&dist_id=${loginUserID}`;
    } else if (CompanyID) {
      // fallback if none of the above
      url += `&company_id=${CompanyID}`;
    }

    try {
      const res = await axios.get(url);
      setUsers(res.data.data || []);
    } catch (err) {
      console.error("Failed to fetch users:", err);
      setUsers([]);
    }
  };

  fetchUsers();
}, [selectedRole, CompanyID, userRole, loginUserID]);


  // 🔹 Fetch assigned keys data
  

    const fetchReports = async () => {
  setLoadingReport(true);
  setErrorReport(null);

  try {
    let url = `https://spillas.com/api/v1/keys/report?sender_id=${loginUserID}&mode=1&page=${reportPage}&per_page=${rowsPerPage}&company_id=${CompanyID}`;

    // 🟢 If a user is selected, filter by receiver_id
    if (selectedUser) {
      url += `&receiver_id=${selectedUser}`;
    }
    // 🟢 If only role is selected (and no specific user)
    else if (selectedRole) {
      url += `&role=${selectedRole}`;
    }

    if (fromDate) url += `&from_date=${fromDate}`;
    if (toDate) url += `&to_date=${toDate}`;

    const res = await axios.get(url);
    setAssignedReports(res.data.data || []);
    setReportTotalPages(res.data.last_page || 1);
    setReportTotal(res.data.total || 0);
  } catch (err) {
    console.error("Failed to fetch assigned reports:", err);
    setErrorReport("Failed to load report");
  } finally {
    setLoadingReport(false);
  }
};

useEffect(() => {
    if (!loginUserID || !CompanyID) return;
    fetchReports();
  }, [loginUserID, CompanyID, reportPage, selectedUser, fromDate, toDate]);

  // 🔹 Reset all filters
  const handleReset = () => {
    setSelectedRole("");
    setUsers([]);
    setSelectedUser("");
    setFromDate("");
    setToDate("");
    setReportPage(1);
  };
  
 const getRoleBadge = (roleId) => {
  const baseStyle =
    "px-2 py-0 rounded-full text-xs font-semibold border flex items-center gap-1 w-fit";

  switch (roleId) {
    case 3:
      return (
        <span className={`${baseStyle}  bg-blue-50 border-blue-300`}>
          <i className="ri-information-line"></i> CNF
        </span>
      );
    case 4:
      return (
        <span className={`${baseStyle} bg-purple-50 border-purple-300`}>
          <i className="ri-information-line"></i> Super Stockist
        </span>
      );
    case 5:
      return (
        <span className={`${baseStyle} bg-orange-50 border-orange-300`}>
          <i className="ri-information-line"></i> Distributor
        </span>
      );
    case 7:
      return (
        <span className={`${baseStyle} bg-green-50 border-green-300`}>
          <i className="ri-information-line"></i> Retailer
        </span>
      );
    default:
      return (
        <span className={`${baseStyle} text-gray-600 bg-gray-50 border-gray-300`}>
          Unknown
        </span>
      );
  }
};

// 🔹 CSV Download Handler
const handleDownload = async () => {
  try {
    if (!loginUserID || !CompanyID) return;

    let url = `https://spillas.com/api/v1/keys/report?sender_id=${loginUserID}&mode=1&company_id=${CompanyID}&page=1&per_page=10000`;

    if (selectedUser) url += `&receiver_id=${selectedUser}`;
    if (fromDate) url += `&from_date=${fromDate}`;
    if (toDate) url += `&to_date=${toDate}`;

    const res = await axios.get(url);
    const rows = res.data?.data || [];

    if (!rows.length) {
      alert("No data to download");
      return;
    }

    // ✅ Define CSV headers
    const headers = [
      "Sr No.",
      "Date",
      "Receiver (Code)",
      "Role",
      "Package",
      "Count",
      "Rate",
      "Amount",
      "Status",
    ];

    // ✅ Generate CSV rows
    const csvRows = [
      headers.join(","), // Header row
      ...rows.map((rep, i) =>
        [
          i + 1,
          new Date(rep.created_at).toLocaleDateString(),
          `${rep.receiver_name} (${rep.receiver_code || "N/A"})`,
          (() => {
            switch (rep.role) {
              case 3:
                return "CNF";
              case 4:
                return "Super Stockist";
              case 5:
                return "Distributor";
              case 7:
                return "Retailer";
              default:
                return "Unknown";
            }
          })(),
          rep.package_name,
          rep.qty,
          `₹${rep.key_rate}`,
          `₹${rep.amount}`,
          "Assigned",
        ].join(",")
      ),
    ];

    // ✅ Convert to CSV Blob
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const urlObject = URL.createObjectURL(blob);

    // ✅ Trigger download
    const link = document.createElement("a");
    link.href = urlObject;
    link.download = `assigned_keys_report.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(urlObject);
  } catch (error) {
    console.error("Failed to download CSV:", error);
    alert("Failed to download report");
  }
};

  return (
    <Card brand={brand} title="Assigned Keys Report">
      {/* 🔹 Filter Section */}
      <div className="flex justify-between items-center flex-wrap gap-3 mb-4">
        {/* Total Count (Left Side) */}
        <div className="bg-green-500 text-white font-semibold px-4 py-2 rounded-lg text-center min-w-[80px]">
          {reportTotal || 0}
        </div>

        {/* Filters (Right Side) */}
        <div className="flex flex-wrap items-center justify-end gap-3 sm:gap-4">
            {/* ✅ Role Select */}
            <select
              value={selectedRole}
              onChange={(e) => {
                setSelectedRole(e.target.value);
                setSelectedUser("");
              }}
              className="sm:w-auto border rounded-lg px-2 py-1.5 sm:px-3 sm:py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none"
            >
              <option value="">Select Role</option>
              {roles
                .filter((r) =>
                  ["CNF", "Super Stockist", "Distributor", "Retailer"].includes(r.name)
                )
                .map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.name}
                  </option>
                ))}
            </select>

            {/* ✅ User Select */}
            <select
              value={selectedUser}
              onChange={(e) => setSelectedUser(e.target.value)}
              disabled={!selectedRole || users.length === 0}
              className="sm:w-[260px] border rounded-lg px-2 py-1.5 sm:px-3 sm:py-2 text-sm focus:ring-2 focus:ring-blue-400 outline-none disabled:bg-gray-100"
            >
              <option value="">Select User</option>
              {users.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.org_code} - {user.business_name}
                </option>
              ))}
            </select>

            {/* ✅ Date Range */}
            <div className="flex flex-wrap items-center gap-1 sm:gap-2 justify-center sm:w-auto">
              <label className="text-xs sm:text-sm font-medium text-gray-700">
                Date Range:
              </label>

              <div className="border rounded-lg px-2 sm:px-3 py-1 sm:py-1.5 sm:w-64 text-gray-700 focus-within:ring-2 focus-within:ring-blue-400">
                <DatePicker
                  selectsRange
                  startDate={fromDate ? new Date(fromDate) : null}
                  endDate={toDate ? new Date(toDate) : null}
                  onChange={(dates) => {
                    const [start, end] = dates;
                    setFromDate(start ? start.toISOString().split("T")[0] : "");
                    setToDate(end ? end.toISOString().split("T")[0] : "");
                  }}
                  dateFormat="yyyy-MM-dd"
                  placeholderText="Select date range"
                  className="w-full text-xs sm:text-sm text-gray-700 outline-none bg-transparent"
                />
              </div>

              <div className="flex gap-2 sm:w-auto justify-end">
              <BlueButton brand={BRAND} onClick={handleReset} className="inline-flex items-center gap-1 w-full sm:w-auto justify-center">
                <XCircle size={14} />
                <span className="hidden sm:inline">Reset</span>
              </BlueButton>

              <BlueButton
                brand={BRAND}
                onClick={handleDownload}
                className="inline-flex items-center gap-1 bg-green-600 hover:bg-green-700"
              >
                <i className="ri-download-2-line"></i>
                <span className="hidden sm:inline">Download</span>
              </BlueButton>


              <BlueButton
                brand={BRAND}
                onClick={() => fetchReports()}
                className="inline-flex items-center gap-1 sm:w-auto justify-center"
              >
                <RefreshCw size={14} />
                <span className="hidden sm:inline">Refresh</span>
              </BlueButton>
            </div>
            </div>

            {/* ✅ Buttons */}
            
          </div>
        </div>  



      {/* 🔹 Data Table */}
      {loadingReport ? (
         <TableSkeleton rows={assignedReports?.length || rowsPerPage} headers={[
              "Sr No.",
              "Date",
              "Receiver (Code)",
              "Role",
              "Package",
              "Count",
              "Rate",
              "Amount",
              "Status",
            ]}/>
      ) : errorReport ? (
        <p className="text-red-500">{errorReport}</p>
      ) : assignedReports.length === 0 ? (
        <p>No data found</p>
      ) : (
        <>
          <SimpleTable
            visibleCols={3}
            headers={[
              "Sr No.",
              "Date",
              "Receiver (Code)",
              "Role",
              "Package",
              "Count",
              "Rate",
              "Amount",
              "Status",
            ]}
            rows={assignedReports.map((rep, i) => [
              (reportPage - 1) * rowsPerPage + i + 1,
              new Date(rep.created_at).toLocaleDateString(),
              `${rep.receiver_name} (${rep.receiver_code || "N/A"})`,
              getRoleBadge(rep.role),
              rep.package_name,
              rep.qty,
              `₹${rep.key_rate}`,
              `₹${rep.amount}`,
              Badge("Assigned", "blue"),
            ])}
          />

          {/* Pagination */}
          <div className="flex gap-2 justify-end mt-4 items-center">
            {/* Prev Button */}
            <button
              disabled={reportPage === 1}
              onClick={() => setReportPage((p) => Math.max(p - 1, 1))}
              className={`px-2 py-1 border rounded text-sm ${
                reportPage === 1
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-white hover:bg-slate-100"
              }`}
            >
              Prev
            </button>

            {/* Page numbers */}
            {(() => {
              const pages = [];
              const maxVisible = 5;
              let start = Math.max(1, reportPage - 2);
              let end = Math.min(reportTotalPages, start + maxVisible - 1);

              if (end - start < maxVisible - 1) {
                start = Math.max(1, end - maxVisible + 1);
              }

              if (start > 1) {
                pages.push(1);
                if (start > 2) pages.push("...");
              }

              for (let i = start; i <= end; i++) {
                pages.push(i);
              }

              if (end < reportTotalPages) {
                if (end < reportTotalPages - 1) pages.push("...");
                pages.push(reportTotalPages);
              }

              return pages.map((p, idx) =>
                p === "..." ? (
                  <span key={idx} className="px-2 text-gray-500">
                    ...
                  </span>
                ) : (
                  <button
                    key={p}
                    onClick={() => setReportPage(p)}
                    className={`px-2 py-1 border rounded text-sm ${
                      reportPage === p
                        ? "bg-blue-600 text-white"
                        : "bg-white hover:bg-slate-100"
                    }`}
                  >
                    {p}
                  </button>
                )
              );
            })()}

            {/* Next Button */}
            <button
              disabled={reportPage === reportTotalPages}
              onClick={() =>
                setReportPage((p) => Math.min(p + 1, reportTotalPages))
              }
              className={`px-2 py-1 border rounded text-sm ${
                reportPage === reportTotalPages
                  ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                  : "bg-white hover:bg-slate-100"
              }`}
            >
              Next
            </button>
          </div>

        </>
      )}
    </Card>
  );
}



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";
// import Badge from "../Components/Badge";
// import { fetchRoles } from "../Data/ROLES";

// export default function AssignedKeysReport({ brand, loginUserID, CompanyID }) {
//   const [assignedReports, setAssignedReports] = useState([]);
//   const [reportPage, setReportPage] = useState(1);
//   const [reportTotalPages, setReportTotalPages] = useState(1);
//   const [loadingReport, setLoadingReport] = useState(false);
//   const [errorReport, setErrorReport] = useState(null);

//   const [roles, setRoles] = useState([]);
//   const [selectedRole, setSelectedRole] = useState("");
//   const [users, setUsers] = useState([]);
//   const [selectedUser, setSelectedUser] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");

//   const rowsPerPage = 10;

//   // 🔹 Load all roles on mount
//   useEffect(() => {
//     const loadRoles = async () => {
//       const loadedRoles = await fetchRoles();
//       const formatted = Object.entries(loadedRoles).map(([id, name]) => ({
//         id,
//         name,
//       }));
//       setRoles(formatted);
//     };
//     loadRoles();
//   }, []);

//   // 🔹 Fetch users when a role is selected
//   useEffect(() => {
//     const fetchUsers = async () => {
//       if (!selectedRole || !CompanyID) return;
//       try {
//         const res = await axios.get(
//           `https://spillas.com/api/v1/org_user?role=${selectedRole}&company_id=${CompanyID}`
//         );
//         setUsers(res.data.data || []);
//       } catch (err) {
//         console.error("Failed to fetch users:", err);
//         setUsers([]);
//       }
//     };
//     fetchUsers();
//   }, [selectedRole, CompanyID]);

//   // 🔹 Fetch assigned key reports when filters change
//   useEffect(() => {
//     if (!loginUserID || !CompanyID) return;

//     const fetchReports = async () => {
//       setLoadingReport(true);
//       setErrorReport(null);

//       try {
//         let url = `https://spillas.com/api/v1/keys/report?sender_id=${loginUserID}&mode=1&page=${reportPage}&per_page=${rowsPerPage}&company_id=${CompanyID}`;

//         if (selectedUser) url += `&receiver_id=${selectedUser}`;
//         if (fromDate) url += `&from_date=${fromDate}`;
//         if (toDate) url += `&to_date=${toDate}`;

//         const res = await axios.get(url);
//         setAssignedReports(res.data.data || []);
//         setReportTotalPages(res.data.last_page || 1);
//       } catch (err) {
//         console.error("Failed to fetch assigned reports:", err);
//         setErrorReport("Failed to load report");
//       } finally {
//         setLoadingReport(false);
//       }
//     };

//     fetchReports();
//   }, [loginUserID, CompanyID, reportPage, selectedUser, fromDate, toDate]);

//   // 🔹 Reset filters
//   const handleReset = () => {
//     setSelectedRole("");
//     setUsers([]);
//     setSelectedUser("");
//     setFromDate("");
//     setToDate("");
//     setReportPage(1);
//   };

//   return (
//     <Card brand={brand} title="Assigned Keys Report">
//       {/* 🔹 Filter Section */}
//       <div className="grid grid-cols-1 sm:grid-cols-5 gap-3 mb-4">
//         {/* Select Role */}
//         <div>
//           <label className="block text-sm font-semibold mb-1">Role</label>
//           <select
//             value={selectedRole}
//             onChange={(e) => {
//               setSelectedRole(e.target.value);
//               setSelectedUser("");
//             }}
//             className="w-full border rounded-lg px-3 py-2 text-sm"
//           >
//             <option value="">Select Role</option>
//             {roles.map((role) => (
//               <option key={role.id} value={role.id}>
//                 {role.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Select User */}
//         <div>
//           <label className="block text-sm font-semibold mb-1">User</label>
//           <select
//             value={selectedUser}
//             onChange={(e) => setSelectedUser(e.target.value)}
//             disabled={!selectedRole || users.length === 0}
//             className="w-full border rounded-lg px-3 py-2 text-sm"
//           >
//             <option value="">Select User</option>
//             {users.map((user) => (
//               <option key={user.id} value={user.id}>
//                 {user.name} ({user.code})
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* From Date */}
//         <div>
//           <label className="block text-sm font-semibold mb-1">From Date</label>
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             className="w-full border rounded-lg px-3 py-2 text-sm"
//           />
//         </div>

//         {/* To Date */}
//         <div>
//           <label className="block text-sm font-semibold mb-1">To Date</label>
//           <input
//             type="date"
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//             className="w-full border rounded-lg px-3 py-2 text-sm"
//           />
//         </div>

//         {/* Reset Button */}
//         <div className="flex items-end">
//           <button
//             onClick={handleReset}
//             className="bg-gray-200 px-4 py-2 rounded-lg text-sm hover:bg-gray-300 w-full"
//           >
//             Reset
//           </button>
//         </div>
//       </div>

//       {/* 🔹 Table Section */}
//       {loadingReport ? (
//         <p>Loading...</p>
//       ) : errorReport ? (
//         <p className="text-red-500">{errorReport}</p>
//       ) : assignedReports.length === 0 ? (
//         <p>No data found</p>
//       ) : (
//         <>
//           <SimpleTable
//             headers={[
//               "Sr No.",
//               "Date",
//               "Receiver (Code)",
//               "Type",
//               "Package",
//               "Count",
//               "Status",
//             ]}
//             rows={assignedReports.map((rep, i) => [
//               (reportPage - 1) * rowsPerPage + i + 1,
//               new Date(rep.created_at).toLocaleDateString(),
//               `${rep.receiver_name} (${rep.receiver_code || "N/A"})`,
//               rep.key_type === 1 ? "Regular" : "Smart",
//               rep.package_name,
//               rep.qty,
//               Badge("Assigned", "blue"),
//             ])}
//           />

//           {/* Pagination */}
//           <div className="flex justify-center gap-2 mt-3">
//             <button
//               disabled={reportPage === 1}
//               onClick={() => setReportPage(reportPage - 1)}
//               className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
//             >
//               Prev
//             </button>
//             <span className="px-3 py-1">
//               {reportPage}/{reportTotalPages}
//             </span>
//             <button
//               disabled={reportPage === reportTotalPages}
//               onClick={() => setReportPage(reportPage + 1)}
//               className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </>
//       )}
//     </Card>
//   );
// }



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Card from "../Components/Card";
// import SimpleTable from "../Components/SimpleTable";
// import Badge from "../Components/Badge";

// export default function AssignedKeysReport({ brand, loginUserID, CompanyID }) {
//   const [assignedReports, setAssignedReports] = useState([]);
//   const [reportPage, setReportPage] = useState(1);
//   const [reportTotalPages, setReportTotalPages] = useState(1);
//   const [loadingReport, setLoadingReport] = useState(false);
//   const [errorReport, setErrorReport] = useState(null);

//   const rowsPerPage = 10;

//   useEffect(() => {
//     if (!loginUserID || !CompanyID) return;

//     const fetchReports = async () => {
//       setLoadingReport(true);
//       setErrorReport(null);
//       try {
//         const res = await axios.get(
//           `https://spillas.com/api/v1/keys/report?sender_id=${loginUserID}&mode=1&company_id=${CompanyID}&page=${reportPage}&per_page=${rowsPerPage}`
//         );

//         setAssignedReports(res.data.data || []);
//         setReportTotalPages(res.data.last_page || 1);
//       } catch (err) {
//         console.error("Failed to fetch assigned reports:", err);
//         setErrorReport("Failed to load report");
//       } finally {
//         setLoadingReport(false);
//       }
//     };

//     fetchReports();
//   }, [loginUserID, CompanyID, reportPage]);

//   return (
//     <Card brand={brand} title="Assigned Keys Report">
//       {loadingReport ? (
//         <p>Loading...</p>
//       ) : errorReport ? (
//         <p className="text-red-500">{errorReport}</p>
//       ) : assignedReports.length === 0 ? (
//         <p>No data found</p>
//       ) : (
//         <>
//           <SimpleTable
//             headers={[
//               "Sr No.",
//               "Date",
//               "Retailer (Code)",
//               "Type",
//               "Package",
//               "Count",
//               "Status",
//             ]}
//             rows={assignedReports.map((rep, i) => [
//               (reportPage - 1) * rowsPerPage + i + 1,
//               new Date(rep.created_at).toLocaleDateString(),
//               `${rep.receiver_name} (${rep.receiver_code || "N/A"})`,
//               rep.key_type === 1 ? "Regular" : "Smart",
//               rep.package_name,
//               rep.qty,
//               Badge("Assigned", "blue"),
//             ])}
//           />

//           <div className="flex justify-center gap-2 mt-2">
//             <button
//               disabled={reportPage === 1}
//               onClick={() => setReportPage(reportPage - 1)}
//               className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
//             >
//               Prev
//             </button>
//             <span className="px-3 py-1">
//               {reportPage}/{reportTotalPages}
//             </span>
//             <button
//               disabled={reportPage === reportTotalPages}
//               onClick={() => setReportPage(reportPage + 1)}
//               className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </>
//       )}
//     </Card>
//   );
// }
